import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const GetScriptsRequest = () => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}Builder/GetBuilderScripting`,
	params: {}
});
